<template>
  <div class="crud_form_wrapper app_settings_class">
    <!-- Start:: Single Step Form Content -->
    <div class="table_title_wrapper">
      <div class="title_text_wrapper">
        <h5 style="color: #EF3405">{{ $t("SIDENAV.settings.general") }}</h5>
      </div>
      <div class="col-12 text-end">
        <v-btn @click="$router.go(-1)" style="color: #EF3405">
          <i class="fas fa-backward"></i>
        </v-btn>
      </div>
    </div>
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- سعر توصيل الطرد -->
          <base-input
            type="number"
            col="6"
            :placeholder="$t('PLACEHOLDERS.package_delivery_price')"
            v-model.trim="data.package_delivery_price"
            required
          />

          <!-- سعر استرجاع الطرد للمندوب -->
          <base-input
            type="number"
            col="6"
            :placeholder="$t('PLACEHOLDERS.package_return_price')"
            v-model.trim="data.package_return_price"
            required
          />

          <!-- نسبة عمولة المندوب -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="input_wrapper" style="position: relative;">
              <base-input
                type="number"
                col="12"
                :placeholder="$t('PLACEHOLDERS.courier_commission_percentage')"
                v-model.trim="data.courier_commission_percentage"
                min="0"
                max="100"
                required
              />
              <span style="position: absolute; left: 15px; top: 50%; transform: translateY(-50%); font-size: 18px; color: #666;">%</span>
            </div>
          </div>

          <!-- نسبة عمولة نقطة التوزيع -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="input_wrapper" style="position: relative;">
              <base-input
                type="number"
                col="12"
                :placeholder="$t('PLACEHOLDERS.distribution_point_commission_percentage')"
                v-model.trim="data.distribution_point_commission_percentage"
                min="0"
                max="100"
                required
              />
              <span style="position: absolute; left: 15px; top: 50%; transform: translateY(-50%); font-size: 18px; color: #666;">%</span>
            </div>
          </div>

          <!-- نسبة عمولة النظام من التوصيل -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="input_wrapper" style="position: relative;">
              <base-input
                type="number"
                col="12"
                :placeholder="$t('PLACEHOLDERS.system_commission_percentage')"
                v-model.trim="data.system_commission_percentage"
                min="0"
                max="100"
                required
              />
              <span style="position: absolute; left: 15px; top: 50%; transform: translateY(-50%); font-size: 18px; color: #666;">%</span>
            </div>
          </div>

          <!-- فترة السماح قبل تفعيل زر الاسترجاع -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="input_wrapper" style="position: relative;">
              <base-input
                type="number"
                col="12"
                :placeholder="$t('PLACEHOLDERS.grace_period_before_return')"
                v-model.trim="data.grace_period_before_return"
                min="0"
                max="10"
                required
              />
              <span style="position: absolute; left: 15px; top: 50%; transform: translateY(-50%); font-size: 14px; color: #666;">{{ $t('PLACEHOLDERS.day') }}</span>
            </div>
          </div>

          <!-- مدة الاستلام بعد قبول الحزمة -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="input_wrapper" style="position: relative;">
              <base-input
                type="number"
                col="12"
                :placeholder="$t('PLACEHOLDERS.pickup_duration_after_acceptance')"
                v-model.trim="data.pickup_duration_after_acceptance"
                required
              />
              <span style="position: absolute; left: 15px; top: 50%; transform: translateY(-50%); font-size: 14px; color: #666;">{{ $t('PLACEHOLDERS.minute') }}</span>
            </div>
          </div>

          <!-- فترة السماح قبل تعليق الطرد -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="input_wrapper" style="position: relative;">
              <base-input
                type="number"
                col="12"
                :placeholder="$t('PLACEHOLDERS.grace_period_before_suspension')"
                v-model.trim="data.grace_period_before_suspension"
                min="0"
                max="200"
                required
              />
              <span style="position: absolute; left: 15px; top: 50%; transform: translateY(-50%); font-size: 14px; color: #666;">{{ $t('PLACEHOLDERS.minute') }}</span>
            </div>
          </div>

          <!-- نطاق استقبال الحزم -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="input_wrapper" style="position: relative;">
              <base-input
                type="number"
                col="12"
                :placeholder="$t('PLACEHOLDERS.package_reception_range')"
                v-model.trim="data.package_reception_range"
                min="1"
                required
              />
              <span style="position: absolute; left: 15px; top: 50%; transform: translateY(-50%); font-size: 14px; color: #666;">{{ $t('PLACEHOLDERS.kilometer') }}</span>
            </div>
          </div>

          <!-- تكلفة الاسترجاع -->
          <base-input
            type="number"
            col="6"
            :placeholder="$t('PLACEHOLDERS.return_cost')"
            v-model.trim="data.return_cost"
            required
          />

          <!-- End:: Time Filtering Delivery Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- End:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AppSetting",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        package_delivery_price: null,
        package_return_price: null,
        courier_commission_percentage: null,
        distribution_point_commission_percentage: null,
        system_commission_percentage: null,
        grace_period_before_return: null,
        pickup_duration_after_acceptance: null,
        grace_period_before_suspension: null,
        package_reception_range: null,
        return_cost: null,
        // End:: Data
      },
      // End:: Data Collection To Send
    };
  },

  computed: {
    // Start:: Vuex Getters
    ...mapGetters({
      getAuthenticatedUserData: "AuthenticationModule/getAuthenticatedUserData",
    }),
    // End:: Vuex Getters
  },

  methods: {
    // Start:: Get Data To Edit
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `settings?key=general`,
        });
        const settings = res.data.data.data[0]?.value;
        this.data.package_delivery_price = settings.package_delivery_price;
        this.data.package_return_price = settings.package_return_price;
        this.data.courier_commission_percentage = settings.courier_commission_percentage;
        this.data.distribution_point_commission_percentage = settings.distribution_point_commission_percentage;
        this.data.system_commission_percentage = settings.system_commission_percentage;
        this.data.grace_period_before_return = settings.grace_period_before_return;
        this.data.pickup_duration_after_acceptance = settings.pickup_duration_after_acceptance;
        this.data.grace_period_before_suspension = settings.grace_period_before_suspension;
        this.data.package_reception_range = settings.package_reception_range;
        this.data.return_cost = settings.return_cost;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Get Data To Edit

    // Start:: Submit Form
    async submitForm() {
      this.isWaitingRequest = true;

      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      REQUEST_DATA.append("key", "general");
      
      if (this.data.package_delivery_price) {
        REQUEST_DATA.append("value[package_delivery_price]", this.data.package_delivery_price);
      }
      if (this.data.package_return_price) {
        REQUEST_DATA.append("value[package_return_price]", this.data.package_return_price);
      }
      if (this.data.courier_commission_percentage !== null) {
        REQUEST_DATA.append("value[courier_commission_percentage]", this.data.courier_commission_percentage);
      }
      if (this.data.distribution_point_commission_percentage !== null) {
        REQUEST_DATA.append("value[distribution_point_commission_percentage]", this.data.distribution_point_commission_percentage);
      }
      if (this.data.system_commission_percentage !== null) {
        REQUEST_DATA.append("value[system_commission_percentage]", this.data.system_commission_percentage);
      }
      if (this.data.grace_period_before_return !== null) {
        REQUEST_DATA.append("value[grace_period_before_return]", this.data.grace_period_before_return);
      }
      if (this.data.pickup_duration_after_acceptance) {
        REQUEST_DATA.append("value[pickup_duration_after_acceptance]", this.data.pickup_duration_after_acceptance);
      }
      if (this.data.grace_period_before_suspension !== null) {
        REQUEST_DATA.append("value[grace_period_before_suspension]", this.data.grace_period_before_suspension);
      }
      if (this.data.package_reception_range) {
        REQUEST_DATA.append("value[package_reception_range]", this.data.package_reception_range);
      }
      if (this.data.return_cost) {
        REQUEST_DATA.append("value[return_cost]", this.data.return_cost);
      }

      try {
        await this.$axios({
          method: "POST",
          url: `settings`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.savedSuccessfully"));
        this.getDataToEdit();
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // Start:: Validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    // End:: Validate Form Inputs
  },

  created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>

<style>
.app_settings_class form .input_wrapper.top_label .form-label {
  font-size: 14px !important;
  top: -10px !important;
}
@media (max-width: 1080px) {
  .app_settings_class form .input_wrapper.top_label .form-label {
    font-size: 13px !important;
    top: -10px !important;
  }
  .app_settings_class form .input_wrapper.top_label input,
  .app_settings_class
    form
    .input_wrapper.top_label.select_wrapper
    .multiselect
    .multiselect__tags {
    padding: 30px 12px !important;
  }
}
</style>

<style lang="scss" scoped>
.all_action {
  display: flex;
  gap: 15px;
}

.add_another {
  border: none;
  padding: 8px;
  width: 40px;
  height: 40px;
  border: 1px solid var(--light_gray_clr);
  border-radius: 50%;
  font-size: 18px;
  color: var(--light_gray_clr);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: auto;

  .fa-trash {
    color: #ff2159;
    cursor: pointer;
  }
}
</style>
